export default {
  "HitPaw Online Audio Converter": "HitPaw Convertitore di Audio Online ",
  "Convert audios to MP3, AAC, FLAC, WMA and more formats for free.": "Converte gratuitamente audio in MP3, AAC, FLAC, WMA e altri formati.",
  'HitPaw Online Image Converter': 'HitPaw Convertitore di Immagini Online ',
  'Convert images to JPG, PNG, BMP, TIFF and more formats for free.': 'Converte gratuitamente le immagini in JPG, PNG, BMP, TIFF e altri formati.',
  'HitPaw Online Video Converter': 'HitPaw Converti Video Online',
  'Convert videos to any formats as your requirements.': 'Converti video in ogni formato in base alle tue esigenze.',
  'Add More Files': 'Aggiunge Altri File',
  'Convert to': 'Converte in',
  'Ready': 'Pronto',
  'Converting': 'Sta convertendo',
  'Video': 'Video',
  'Audio': 'Audio',
  'Image': 'Immagine',
  'Retry': 'Riprova',
  'Download All': 'Download Tutto',
  'Download Desktop': 'Download Desktop',
  'Continue Editing': 'Continua l’Editing',
  'Convert': 'Converti',
  'Cut': 'Taglia',
  'Speed': 'Velocità',
  'Crop & Rotate': 'Ritaglia & Ruota',
  'Resize': 'Ridimensiona',
  'Extract': 'Estrai',
  'Add Music': 'Aggiungi Musica',
  'Subtitles': 'Sottotitoli',
  'Merge': 'Unisci',
  'Watermark Remover': 'Rimozione Filigrana',
  'Add Watermark': 'Aggiungi Filigrana',
  'Please select a file to use': 'Seleziona un file da utilizzare {{work}}',
  'Batch Processing': 'Batch Processing',
};
